import { React, useEffect, useState } from 'react'
import gsap from 'gsap'
import '../../stylesheets/CyclingTextSS.css'

function CyclingText({text, wordArr, className}) {

    const words = wordArr;
    const [count, setCount] = useState(0);
    //setInterval, every second, changed value of i

    useEffect(() => {
        const interval = setInterval(() => {
            //let t = document.getElementsByClassName('t')[0];
            setCount(
                (count >= words.length - 1) ? 0 : count + 1
            )
            gsap.fromTo('.fade',{opacity:0},{opacity:1, duration:0.35});
        }, 2000)
        return () => clearInterval(interval);
    })
    return (
        <div id='title' className={className}>
            <p id='span'>{text}<br></br><span id="changing" className="fade">{words[count]}</span></p>
        </div>
    )
}

export default CyclingText